import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { UniversalLink } from "../UniversalLink"
import { NavLink } from "./NavLink"
import { homeNavigation, navigation } from "./navigation"
import "./footer.scss"

export const Footer = () => (
  <footer>
    <nav className="nav">
      <NavLink nav={homeNavigation} />

      <div className="md:flex">
        <ul className="menu">
          {navigation.map(
            (nav) =>
              !nav.home && (
                <li key={nav.name}>
                  <NavLink nav={nav} key={nav.key} />
                </li>
              )
          )}
        </ul>

        <ul className="menu menu-social">
          <li>
            <UniversalLink
              to="mailto:info@xrplgrants.org"
              className={`bg-[url('/images/social/email-circle.png')] hover:bg-none hover:bg-magenta-50`}
            >
              <StaticImage
                src="../../../static/images/social/email-logo.png"
                alt="Email"
              />
            </UniversalLink>
          </li>
          <li>
            <UniversalLink
              to="https://www.twitch.tv/ripplexdev"
              className={`bg-[url('/images/social/twitch-circle.png')] hover:bg-none hover:bg-blue-purple-50`}
            >
              <StaticImage
                src="../../../static/images/social/twitch-logo.png"
                alt="Twitch"
              />
            </UniversalLink>
          </li>
          <li>
            <UniversalLink
              to="https://xrpldevs.org/"
              className={`discord bg-[url('/images/social/discord-circle.png')] hover:bg-none hover:bg-blue-50`}
            >
              <StaticImage
                src="../../../static/images/social/discord-logo.png"
                alt="Discord"
              />
            </UniversalLink>
          </li>
        </ul>
      </div>

      <UniversalLink to="/terms" className="nav-link nav-link-terms">
        v1.5.0 - Terms
      </UniversalLink>
    </nav>
  </footer>
)
